<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            <div>Nastavení (developerský mód)</div>
        </div>

        <button mat-dialog-close type="button" [attr.data-testid]="'admin-dialog-button-close'">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="hypo-dialog-content flex flex-col gap-4">
        @if (mortgage) {
            <div class="flex flex-col gap-4">
                <div class="flex flex-row gap-4">
                    <div>mortgage id: {{ mortgage._id }}</div>
                    <mat-icon
                        (click)="copyDealIdToClipboard(mortgage._id, tooltip)"
                        matTooltip="Copied"
                        #tooltip="matTooltip"
                        [attr.data-testid]="'admin-dialog-button-copy-deal-id'"
                        [matTooltipDisabled]="true">
                        content_copy
                    </mat-icon>
                </div>
                <div class="flex justify-start items-center">
                    <a
                        [href]="'https://portal.hyponamiru.dev/cases/mortgage/' + mortgage._id"
                        target="_blank"
                        [attr.data-testid]="'admin-dialog-button-open-portal'"
                        class="flex flex-row gap-2 justify-start items-center">
                        <span>Platforma</span>
                        <mat-icon>arrow_forward</mat-icon>
                    </a>
                </div>
            </div>
        }
        @if (mortgage) {
            <div [formGroup]="formGroup" class="flex flex-col">
                <app-hypo-select
                    [label]="'Název kroku'"
                    [originalList]="stepOptionList"
                    [valueVisibleInLabel]="true"
                    [testId]="'admin-dialog-select-step'"
                    formControlName="stepControl">
                </app-hypo-select>
            </div>
        } @else {
            <div>Není načtená žádná hypotéka</div>
        }

        <div class="hypo-dialog-footer flex flex-row items-center justify-around">
            @if (isDesktop) {
                <button
                    (click)="setMobileMode()"
                    class="btn btn-sm orange"
                    [attr.data-testid]="'admin-dialog-button-mobile'"
                    mat-button>
                    Mobil
                </button>
            }
            @if (!isDesktop) {
                <button
                    (click)="setDesktopMode()"
                    class="btn btn-sm orange"
                    [attr.data-testid]="'admin-dialog-button-desktop'"
                    mat-button>
                    Desktop
                </button>
            }
            <button
                (click)="changeStep()"
                class="btn btn-sm orange admin-button-change-step"
                [attr.data-testid]="'admin-dialog-button-change-step'"
                mat-button>
                Změnit stage
            </button>
        </div>
    </div>
</mat-dialog-content>
